"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _translations = require("../../libs/translationsUtils/translations");

var _default = {
  requires: 'widget',
  init: function init(editor) {
    var commandName = 'insidedEmoji';
    editor.ui.addButton('InsidedEmoji', {
      label: (0, _translations.t)('Forum', 'wysiwyg.emoji.btn.title'),
      command: commandName,
      icon: 'insided-icons/emoji.svg',
      toolbar: 'insert,0'
    });
    editor.addCommand(commandName, {
      exec: function exec(editor) {
        editor.fire('emojiSelect', {
          onSelect: function onSelect(selectedEmoji) {
            editor.insertHtml(selectedEmoji.split('-').map(function (s) {
              return String.fromCodePoint('0x' + s);
            }).join(''));
          }
        });
      }
    });
    editor.widgets.add('emoji-img', {
      upcast: function upcast(elem) {
        return elem.name === 'img' && elem.attributes.src && elem.attributes.src.match('emojione');
      },
      inline: true
    });
  }
};
exports.default = _default;